module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/kids-09af82f6b6eace14312d7337d86deb87.webp";